export const getRouteFromLoanStageService = ({ stage = "", source = "" }) => {
  if (
    stage === "PERSONAL_START" ||
    stage === "NSDL_COMPLETE" ||
    stage === "PROFESSIONAL_START" ||
    stage === "KARZA_START" ||
    stage === "PROFESSIONAL_VERIFY" ||
    stage === "SELF_EMPLOYED_LEAD_CAPTURED"
  ) {
    return "/" + source + "/details";
  } else if (stage === "UDYAM_START") {
    return `/${source}/udyam`;
  } else if (
    stage === "EMAIL_OTP_VERIFICATION"
  ) {
    return "/" + source + "/detailsVerify";
  } else if (
    stage === "NSTP_START" ||
    stage === "NSTP_PENDING" ||
    stage === "NSTP_QUEUE"
  ) {
    return "/" + source + "/nstp";
  } else if (
    stage === "DOC_UPLOAD"
  ) {
    return "/" + source + "/docUpload";
  } else if (
    stage === "INCOME_START" ||
    stage === "TARTAN_INCOMPLETE" ||
    stage === "PERFIOS_INCOMPLETE" ||
    stage === "TARTAN_START" ||
    stage === "PERFIOS_START"
  ) {
    return "/" + source + "/income";
  } else if (stage === "CE_START" || stage === "CE_INCOMPLETE" || stage === "R1_LINE_OFFER" || stage === "UDYAM_DEROG_START" || stage === "HUNTER") {
    return "/" + source + "/loading";
  } else if (stage === "IPO_START") {
    return "/" + source + "/ipo";
  } else if (stage === "UPSELL_ADDRESS_START") {
    return "/" + source + "/upsellVerifyDetails";
  } else if (stage === "SELFIE_START") {
    return "/" + source + "/selfie";
  } else if (
    stage === "VERIFY_DETAILS_START" ||
    stage === "OKYC_START" ||
    stage === "OKYC_DONE"  ||
    stage === "OKYC_PENDING"
  ) {
    return "/" + source + "/verifyDetails";
  } else if (
    stage === "VKYC_START" ||
    stage === "VKYC_IN_PROGRESS" 
  ) {
    return "/" + source + "/verificationPending";
  } else if (
    stage === "BANK_START" ||
    stage === "EMANDATE_START" ||
    stage === "PENNYDROP_START" ||
    stage === "EMANDATE_INCOMPLETE" ||
    stage === "EMANDATE_HOLD" ||
    stage === "EMANDATE" ||
    stage === "EMANDATE" ||
    stage === "EMANDATE" ||
    stage === "EMANDATE" ||
    stage === "EMANDATE"
  ) {
    return "/" + source + "/bankDetails";
  } else if (stage === "REFERENCE_START") {
    return "/" + source + "/reference";
  } else if (stage === "REVIEW_START" || stage === "REVIEW_EMPLOYMENT_VERIFY") {
    return "/" + source + "/review";
  } else if (stage === "REVIEW_IPO_START") {
    return "/" + source + "/ipo";
  } else if (stage === "AGREEMENT_START") {
    return "/" + source + "/agreement";
  } else if (
    (stage === "DISBURSEMENT_REVERIFY" && source === "epl") ||
    stage === "DOCUMENT_SUBMITTED" ||
    stage === "READY_FOR_DISBURSEMENT"
  ) {
    return "/" + source + "/verifyCompanyDetails";
  } else if (
    stage.startsWith("DISBURS") ||
    stage === "DISBURSEMENT_START" ||
    stage === "DISBURSEMENT_REVERIFY" ||
    stage === "DISBURSED_START" ||
    stage === "DISBURSEMENT_IN_PROGRESS" ||
    stage === "DISBURSEMENT_COMPLETED" ||
    stage === "DISBURSEMENT_ERROR" ||
    stage === "DISBURSED_INCOMPLETE" ||
    stage === "DISBURSED_ERROR"
  ) {
    return "/" + source + "/offer";
  } else if (stage === "index") {
    return "/" + source + "/index";
  } else if (stage === "error") {
    return "/" + source + "/error";
  } else if (stage === "pageNotFound") {
    return "/" + source + "/pageNotFound";
  } else if (
    stage === "PROFESSIONAL_REJECT" ||
    stage === "UDYAM_REJECT" ||
    stage === "COMPANY_REJECT" ||
    stage === "CE_REJECT" ||
    stage === "DS_PARSER_REJECT" ||
    stage === "INCOME_REJECT" ||
    stage === "OCR_OKYC_REJECT" ||
    stage === "FACEMATCH_OKYC_REJECT" ||
    stage === "OKYC_PAGE_REJECT" ||
    stage === "EMANDATE_REJECT" ||
    stage === "PAN_ESSENTIALS_REJECT" ||
    stage === "ZUMIGO_REJECT" ||
    stage === "CEPOLLING_REJECT" ||
    stage === "PAN_ALREADY_ACTIVE_REJECT" ||
    stage === "PAN_ALREADY_DISBURSED_REJECT" ||
    stage === "ADDRESS_REJECT" ||
    stage === "PAN_MOBILE_MISMATCH_REJECT" ||
    stage === "VERIFY_PAN_MAX_RETRY_REJECT" ||
    stage === "NSTP_REJECT" ||
    stage === "PAN_VERIFICATION_REJECT" ||
    stage === "A8_INCOME_REJECT" ||
    stage === "GEOTAG_REJECT" ||
    stage === "VKYC_REJECT" ||
    stage === "OTP_REJECT" ||
    stage === "HUNTER_REJECT" ||
    stage === "rejected"
  ) {
    return "/" + source + "/rejected";
  } else {
    return "/" + source + "/login";
  }
};
